import Axios from 'axios'
import { API_URL } from '@app/constants/endpoints'

const ENDPOINT = (id) => `${API_URL}/api/scenes/${id}/conditions`

const postCondition = (accessToken, id, type) => Axios.post(ENDPOINT(id), type, {
  headers: { 'Access-Token': accessToken },
})

export default {
  postCondition,
}
